export const inputColumn6 = 'col-span-12 sm:col-span-4 lg:col-span-2';
export const inputColumn5 = 'col-span-12 sm:col-span-3 md:col-span-1'; // only to be used with grid5 component
export const inputColumn4 = 'col-span-12 sm:col-span-3';
export const inputColumn3 = 'col-span-12 sm:col-span-4';
export const inputColumn2 = 'col-span-12 sm:col-span-6';
export const inputClassname = 'w-full';
export const numInputClassname = 'w-full text-right';
